import { css } from '@terra/ui-styled-system';

const CONVERSATION_LINE_GAP = '6px';
const CONVERSATION_TURN_GAP = '16px';
const CONVERSATION_TURN_LEAD = '10px';

export const chatRowStyles = css({
  '&:not(:empty)': { paddingBottom: CONVERSATION_LINE_GAP },
});

export const chatUserRowStyles = css({
  '&:not(:empty)': { paddingBottom: CONVERSATION_TURN_GAP },
});

export const chatLaterTurnRowStyles = css({
  '&:not(:empty)': { paddingTop: CONVERSATION_TURN_LEAD },
});
